const setStateMutation = (state, payload) => {
    Object.assign(state, payload);
    setFilteredHistoriesMutation(state);
}

const resetFilterMutation = (state, payload) => {
    state.filters[payload].options.forEach(option => {
        option.selected = false;
    });
}

const setSortMutation = (state, payload) => {
    state.sort = payload;
}

const setListViewMutation = (state, payload) => {
    state.listView = payload;
}

const setPositionMutation = (state, payload) => {
    state.position = payload;
}

const setZoomMutation = (state, payload) => {
    state.zoom = payload;
}

const setSelectedHistoryMutation = (state, payload) => {
    state.selected = payload;
}

const removeFilterMutation = (state, payload) => {
    const index = state.filters[payload.type].options.findIndex(option => option.value === payload.value);
    if(index > -1) {
        state.filters[payload.type].options[index].selected = false;
    }
}

const resetAllFiltersMutation = (state) => {
    Object.keys(state.filters).forEach(key => {
        state.filters[key].options.forEach(option => {
            option.selected = false;
        });
    });
}

const setPageMutation = (state, payload) => {
    state.page = payload;
}

const setFilteredHistoriesMutation = (state) => {
    state.filteredHistories = state.histories.filter((history) => {
        const keys = Object.keys(state.filters);
        let passed = true;
        let i = 0;

        while(passed && i < keys.length) {
            const filter = state.filters[keys[i]];
            const selected = filter.options.filter(f => f.selected);
            if(selected.length) {
                passed =  history[keys[i]].length ? history[keys[i]].some((val) => selected.findIndex((s) => s.value === val) > -1) : false;
            }
            
            i++;
            if(!passed) {
                break;
            }
        }
        return passed;
    })
    .sort((a,b) => a.title.localeCompare(b.title, 'sv', { sensitivity: 'base' }))
}

const setFiltersChangedMutation = (state) => {
    state.filtersChanged = new Date().getTime();
}


const mutations = {
    setState: setStateMutation,
    resetFilter: resetFilterMutation,
    setSort: setSortMutation,
    setListView: setListViewMutation,
    setPosition: setPositionMutation,
    setZoom: setZoomMutation,
    removeFilter: removeFilterMutation,
    resetAllFilters: resetAllFiltersMutation,
    setPage: setPageMutation,
    setSelectedHistory: setSelectedHistoryMutation,
    setFilteredHistories: setFilteredHistoriesMutation,
    setFiltersChanged: setFiltersChangedMutation
}

export default mutations;